import { render, staticRenderFns } from "./ChairInitDevice.vue?vue&type=template&id=6c643ce3&scoped=true&"
import script from "./ChairInitDevice.vue?vue&type=script&lang=js&"
export * from "./ChairInitDevice.vue?vue&type=script&lang=js&"
import style0 from "./ChairInitDevice.vue?vue&type=style&index=0&id=6c643ce3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c643ce3",
  null
  
)

export default component.exports